<template>
  <main role="main" class="col content-spacing">
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-bottom"
    >
      <h1 class="h2" v-if="viewData.account">
        Comissões {{ viewData.account.user.name }}
      </h1>
    </div>

    <b-row v-if="this.viewData.account">
      <b-col>
        <b-breadcrumb
          :items="[
            {
              text:
                'Lista de ' +
                this.getProfileName(this.viewData.account.profile),
              href: '/#/' + this.viewData.account.profile + 's',
            },
            {
              text: 'Comissões',
              href: '#',
              active: true,
            },
          ]"
        ></b-breadcrumb>
      </b-col>
    </b-row>

    <loading-list v-if="viewData.loading"></loading-list>

    <div
      v-else-if="
        !viewData.loading && (hasBillingComission() || hasInvestmentComission())
      "
      class="table-responsive"
    >
      <b-tabs content-class="mt-3">
        <b-tab title="Comissões de fatura a receber" active>
          <sales-comissions-index-report-table
            :list="this.getPending()"
          ></sales-comissions-index-report-table>
        </b-tab>
        <b-tab title="Comissões de investimentos a receber">
          <sales-comissions-index-report-invesments-table
            :list="this.getPendingInvestment()"
          >
          </sales-comissions-index-report-invesments-table>
        </b-tab>
        <b-tab title="Comissões de fatura recebidas">
          <sales-comissions-index-report-table
            :list="this.getDone()"
          ></sales-comissions-index-report-table>
        </b-tab>
        <b-tab title="Comissões de investimentos recebidas">
          <sales-comissions-index-report-invesments-table
            :list="this.getDoneInvestment()"
          >
          </sales-comissions-index-report-invesments-table>
        </b-tab>
      </b-tabs>
    </div>
    <empty-list v-else-if="!viewData.loading"></empty-list>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import moment from 'moment-timezone';

const API = new Api();

export default {
  name: 'sales-comissions-index-report',
  data: function() {
    return {
      state: {
        list: [],
        listInvestors: [],
        start: '',
        end: '',
        value: 0,
      },
      viewData: {
        loading: true,
        saving: false,
        errors: [],
        states: [],
        userId: 0,
        accountId: 0,
        user: null,
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    moment.locale('pt-BR');

    try {
      const result = await API.post('/execute', {
        path: '/account/' + this.$route.params.accountId,
        method: 'get',
      });

      this.viewData.account = result.model;
    } catch (ex) {
      this.$toast.error(helpers.getFirstError(ex));
      return;
    }

    await this.getAll();
  },
  methods: {
    hasBillingComission() {
      return this.state.list && this.state.list.length;
    },
    hasInvestmentComission() {
      return this.state.listInvestors && this.state.listInvestors.length;
    },
    getProfileName(profile) {
      if (profile && profile === 'consumer') {
        return 'Consumidores';
      } else if (profile && profile === 'trader') {
        return 'Comercializadores';
      } else if (profile && profile === 'partner') {
        return 'Parceiros';
      } else if (profile && profile === 'investor') {
        return 'Investidores';
      } else {
        return 'Usuários';
      }
    },
    getDone() {
      return this.state.list.filter(f => f.billing.status === 'done');
    },
    getPending() {
      return this.state.list.filter(f => f.billing.status !== 'done');
    },
    getDoneInvestment() {
      return this.state.listInvestors.filter(f => f.status === 'done');
    },
    getPendingInvestment() {
      return this.state.listInvestors.filter(f => f.status !== 'done');
    },
    formatDate(date) {
      return moment(date).format('L');
    },
    async getAll() {
      try {
        const result = await API.post('/execute', {
          path: `/account/${this.viewData.account.id}/sales-comissions-report`,
          method: 'get',
        });

        const resultInvestors = await API.post('/execute', {
          path: `/account/${this.viewData.account.id}/investments/comissions`,
          method: 'get',
        });

        this.state.list = result.model;
        this.state.listInvestors = resultInvestors.model;
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
  },
  components: {
    'sales-comissions-index-report-table': require('./comission-table.vue')
      .default,
    'sales-comissions-index-report-invesments-table': require('./investments-table.vue')
      .default,
  },
};
</script>
